import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { eduLoginButtonLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy EDU-login button envelope. `type: z.literal('zero')`
 * is required here (no `.optional()`): a button created inside a zero block must
 * carry the tag end-to-end. Inner data uses the extended-position grid.
 */
export const eduLoginButtonLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('edu-login-button'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: eduLoginButtonLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
